import { Controller } from '@hotwired/stimulus';

// Leaves one tab visible between two clicks.
const SCROLL_RATIO = 0.8;

// Bootstrap `md`: below it, swiping replaces the chevrons.
const MIN_WIDTH_FOR_CONTROLS = 768;

export default class ScrollableTabsController extends Controller {
  static targets = ['viewport', 'backward', 'forward']

  refreshControls = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.viewportTarget;
    const scrollable = this.wideEnoughForControls && scrollWidth > clientWidth;

    this.backwardTarget.hidden = !scrollable;
    this.forwardTarget.hidden = !scrollable;

    // `invisible` and not `hidden`: keeps the slot, so the ribbon never shifts on a click.
    this.backwardTarget.classList.toggle('invisible', scrollLeft <= 0);
    this.forwardTarget.classList.toggle('invisible', scrollLeft + clientWidth >= scrollWidth);
  }

  connect() {
    this.viewportTarget.addEventListener('scroll', this.refreshControls);
    window.addEventListener('resize', this.refreshControls);
    this.refreshControls();
  }

  disconnect() {
    this.viewportTarget.removeEventListener('scroll', this.refreshControls);
    window.removeEventListener('resize', this.refreshControls);
  }

  scrollBackward() {
    this.scrollHorizontallyBy(-this.stepInPixels);
  }

  scrollForward() {
    this.scrollHorizontallyBy(this.stepInPixels);
  }

  scrollHorizontallyBy(pixels) {
    this.viewportTarget.scrollBy({ left: pixels, behavior: this.scrollBehavior });
  }

  get stepInPixels() {
    return this.viewportTarget.clientWidth * SCROLL_RATIO;
  }

  get wideEnoughForControls() {
    return window.innerWidth >= MIN_WIDTH_FOR_CONTROLS;
  }

  get scrollBehavior() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }
}
